import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import loadArtemisFonts from '../../../v2/components/ui/loadArtemisFonts';
import Translation from '../../../v2/lang/Translation';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import {isGuest} from '../../../v2/selectors/selectors';
import Typography from '../../../v2/style-helper/Typography';
import LoyaltyPointsStarIcon from './LoyaltyPointsIcons/LoyaltyPointStarIcon.svg';

const icons = {
  lfint: LoyaltyPointsStarIcon,
};

const useStyles = createUseStyles({
  loyaltyPointsEarntMessage: {
    marginBottom: '1em',
    textAlign: 'left',
  },

  title: {
    fontSize: 24,
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: [10, 0],
    color: '#e5007d',
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[Typography.large1])
      && loadArtemisFonts(props.theme.typography[Typography.large1]),
    }),
  },

  brandIcon: {
    marginRight: '1em',
  },
});

export function LoyaltyPointsEarntMessage(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  if (!props.showLoyalty || props.loyaltyPoints <= 0) return null;
  const brandIcon = icons[props.brand];
  return (
    <div className={classes.loyaltyPointsEarntMessage} data-test="LoyaltyPointsEarntMessage">
      <div className={classes.title} data-test="LoyaltyPointsEarntMessage__title">
        {brandIcon
        && <img className={classes.brandIcon} data-test="LoyaltyPointsEarntMessage__brandIcon" src={brandIcon} alt="" /> }
        <Translation>
          {`loyalty.points.name.${props.brand}`}
        </Translation>
      </div>
      <span>
        {props.loyaltyPointsText.map(message => (
          <div>
            <Translation placeholderValues={[props.loyaltyPoints]}>
              {message}
            </Translation>
          </div>
        ))}
      </span>
    </div>
  );
}

const mapStateToProps = (state) => {
  const collectionMessage = isGuest(state)
    ? 'loyalty.point.collection.message.guest'
    : 'loyalty.point.collection.message';
  
  return {
    brand: state.start.siteDataV2.siteCode || 'default',
    loyaltyPoints: state.start.order.loyaltyPoints ? state.start.order.loyaltyPoints.totalPointsEarned : 0,
    showLoyalty: state.start.settings.loyalty_banner,
    loyaltyPointsText: [collectionMessage, 'loyalty.points.added.to.total.message',
      'view.loyalty.points.in.account.message'],
    isUsingArtemisStyles: isUsingArtemisStyles(state),
  };
};

LoyaltyPointsEarntMessage.propTypes = {
  loyaltyPoints: PropTypes.number.isRequired,
  brand: PropTypes.string.isRequired,
  showLoyalty: PropTypes.bool.isRequired,
  loyaltyPointsText: PropTypes.arrayOf(PropTypes.string).isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(LoyaltyPointsEarntMessage);
